import { Lock } from 'lucide-react';
import { Link } from 'react-router';
import { Button } from '../../../ui/Button';
import { Page } from '../../../ui/Page';
import { PageHeader } from '../../../ui/PageHeader';
import { Section } from '../../../ui/Section';
import { EmptyState } from '../../../ui/States';

/** Spotkania należą do modułu Klienci (DECISIONS): bez niego spokojny komunikat zamiast danych. */
export function MeetingsNoAccess() {
  return (
    <Page>
      <PageHeader title="Spotkania" />
      <Section className="mt-6">
        <EmptyState
          icon={Lock}
          title="Brak dostępu do modułu Klienci"
          description="Spotkania są częścią modułu Klienci. Jeśli potrzebujesz dostępu, poproś administratora workspace’u."
          action={
            <Button asChild variant="secondary">
              <Link to="/dzis">Wróć do Dziś</Link>
            </Button>
          }
        />
      </Section>
    </Page>
  );
}
